var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-complementary-orange mb-6 mt-4 uppercase"},[_c('span',{staticClass:"lang-de"},[_vm._t("de")],2),_c('span',{staticClass:"lang-en"},[_vm._t("en")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }